import React from "react";
import { connect } from "react-redux";
import DataGrid, {
  Scrolling,
  Sorting,
  HeaderFilter,
  Column,
} from "devextreme-react/ui/data-grid";
import { changeSubMenu, getListadoMedidasPorPlanMovilidad, openCloseModalSubMedida } from "../actions";
import Loading from "../../Util/Loading";
import ModalSubMedida from "./modalSubMedida";
import { compareDateToday, dateFormat, nombrePlanMovilidad, scrollElementToTop } from "../functions";

const ColoredLine = ({ color }) => (
  <hr
    style={{
      color,
      backgroundColor: color,
      height: 1,
    }}
  />
);

class ConfiguracionPlanMovilidad extends React.PureComponent {
  constructor(props) {
    super(props);
    this.props.dispatch(getListadoMedidasPorPlanMovilidad(this.props.idplanMovilidad));
  }

  handleOpenModalEdit = (e) => {
    this.props.dispatch(openCloseModalSubMedida(true, e.data));
  }

  componentDidMount = () => {
    scrollElementToTop("configuracion-planmovilidad");
  }

  render() {
    return (
      <section id="configuracion-planmovilidad">
        { (this.props.isMedidasLoading || !this.props.medidasGeneradas) && <Loading /> }
        <ModalSubMedida />
        <div className="row">
          <div className="col-md-10 PM-tipo-denuncias-select">
            <div className="PM-section-title PM-title">Planes de Movilidad</div>
          </div>
          <div className="col-md-2 PM-botones-top">
            <button
              className="btn PM-dx-button-plan PM-dx-button-plan-100"
              onClick={() => {
                this.props.dispatch(changeSubMenu(0));
              }}
            >Volver
            </button>
          </div>
        </div>
        <div className="panel-group" id="plan" role="tablist" aria-multiselectable="true">
          <div className="panel panel-default PM-borde-tabla">

            <div className="PM-panel-heading-plan PM-fondo-table" role="tab" id="headingOne">
              <h4 className="panel-title">
                <div className="row">
                  <div className="col-sm-7 PM-informativo">
                    <span>Plan</span>
                    <p><strong>{nombrePlanMovilidad(this.props.fechaCreacion,this.props.sucursalId)}</strong></p>
                  </div>
                  <div className="col-sm-3 PM-informativo">
                    <span>Encargado</span>
                    <p><strong>{this.props.nombreusuario}</strong></p>
                  </div>
                  <div className="col-sm-2">
                    <div className="PM-plan-ejecucion">
                        Borrador
                    </div>
                  </div>
                </div>
              </h4>
            </div>

            {this.props.medidasPlanMovilidad.map((plan, id) => (
              <div key={id}>
                <div className="col-xs-12 col-md-12">
                  <ColoredLine color="#F2F2F2" />
                </div>
                <h2 style={{ paddingLeft: 30, paddingRight: 30, fontSize: 18, marginBottom:30, marginTop:30, marginLeft:0, marginRight:0 }}>Medida: {plan.descripcion}</h2>
                <DataGrid
                  showBorders={false}
                  dataSource={plan.tblPlanSubMedida}
                  className="roles-empresa PM-vertical-middle"
                  showColumnLines={false}
                  showRowLines={false}
                  columnAutoWidth={false}
                  rowAlternationEnabled
                  noDataText="No hay sub medidas"
                  ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
                  loadPanel={{
                    enabled: true,
                  }}
                >

                  <HeaderFilter visible={false} />
                  <Sorting mode="multiple" />
                  <Scrolling columnRenderingMode="virtual" />

                  <Column
                    caption="¿Habilitada?"
                    alignment="center"
                    width="100"
                    cellComponent={(row) => (<div className="tp-10">{row.data.subMedidaElegida ? <i className="achs-icon" style={{ color: "green", fontSize: 55, marginTop: -9 }}> c </i> : <i className="achs-icon"style={{ color: "red", fontSize: 55, margin: -7 }}> d </i>}</div>)}
                  />

                  <Column
                    caption="Nombre de acción"
                    // dataField="descripcion"
                    width="450"
                    cellComponent={React.memo((props) => (
                      <div className="pt-10 text-left PM-descripcion PM-info">
                          <p>{props.data.descripcion}</p>
                      </div>
                    ))}
                  />

                  <Column
                    alignment="right"
                    cellComponent={React.memo((props) => (
                      <div className="col-sm-2 pt-10 text-right">
                        <span className="PM-plan-pendientes">
                          {`${props.data.totalTareasPendientes} tareas pendientes`}
                        </span>
                      </div>
                    ))}
                  />

                  <Column
                    alignment="center"
                    cellComponent={React.memo((props) => (
                      <div className="col-sm-2 text-right">
                        <span className="PM-label-size">Fecha inicio</span><br />
                        {(compareDateToday(props.data.fechaInicio) === -1 && props.data.subMedidaElegida) ?
                          <span style={{ color: "red" }}>{dateFormat(props.data.fechaInicio)}</span>
                          :
                          <span>{props.data.fechaInicio ? dateFormat(props.data.fechaInicio) : "Por definir"}</span>}
                      </div>
                    ))}
                  />

                  <Column
                    alignment="center"
                    cellComponent={React.memo((props) => (
                      <div className="col-sm-2 text-right">
                        <span className="PM-label-size">Fecha límite</span><br />
                        <span>{props.data.fechaLimite ? dateFormat(props.data.fechaLimite) : "Por definir"}</span>
                      </div>
                    ))}
                  />

                  {
                    !this.props.esEncargado?
                    <Column
                      alignment="center"
                      width="0"
                      cellComponent={React.memo(() => (<div></div>))}
                    />
                    :
                    <Column
                      alignment="center"
                      width="100"
                      cellComponent={React.memo((props) => (<div className="btn PM-dx-button-plan PM-dx-button-plan-100" onClickCapture={() => this.handleOpenModalEdit(props)}>configurar</div>))}
                    />
                  }

                </DataGrid>
              </div>
            ))}
          </div>
        </div>

        {
          this.props.planesMovilidad > 0?
            <div className="panel-group" id="plan" role="tablist" aria-multiselectable="true" style={{ marginTop: 10 }}>
              <div className="panel panel-default PM-borde-tabla">
                {this.props.planesMovilidad.map((p, k) => (
                  <div key={k} className="PM-panel-heading-plan PM-fondo-table" role="tab" id="headingOne">
                    <h4 className="panel-title">
                      <div className="row">
                        <div className="col-sm-7 PM-informativo">
                          <span>Plan</span>
                          <p>{nombrePlanMovilidad(p.fechaCreacion,p.idcentro)}</p>
                        </div>
                        <div className="col-sm-3 PM-informativo">
                          <span>Encargado</span>
                          <p>{p.rutusuarioNavigation.nombre}</p>
                        </div>
                        <div className="col-sm-2">
                          <div className="PM-plan-finalizada">
                            Finalizado
                          </div>
                        </div>
                      </div>
                    </h4>
                  </div>
                ))}
              </div>
            </div>
          :
          <div></div>
        }

        <div className="PM-footer">&nbsp;</div>

      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  fechaCreacion: state.planMovilidad.fechaCreacion,
  medidasPlanMovilidad: state.planMovilidad.medidasPlanMovilidad,
  isMedidasLoading: state.planMovilidad.isMedidasLoading,
  medidasGeneradas: state.planMovilidad.medidasGeneradas,
  FirstName: state.global.userData.FirstName,
  LastName: state.global.userData.LastName,
  planesMovilidad: state.planMovilidad.planesMovilidad,
  nombreusuario: state.planMovilidad.nombreusuario,
  esEncargado: state.planMovilidad.esEncargado,
  sucursalId: state.global.sucursalId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfiguracionPlanMovilidad);
